import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditElementForm } from './-components/ElementForm';

export const Route = createFileRoute('/_authenticated/rtelements/$elementId')({
    context: ({ params }) => ({
        rtElementQuery: client.rtelements.rtElements.get.queryOptions(
            { params: { id: params.elementId } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.rtElementQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: EditElementForm,
});
